import { Session } from 'next-auth';

/**
 * Module-level session cache.
 *
 * Populated by `<SessionCacheSync>` inside the SessionProvider tree
 * so that non-React code (axios interceptors in favoritesApi / marketplaceApi)
 * can read the session without calling `getSession()` which always hits
 * `/api/auth/session` over the network.
 */
let cachedSession: Session | null = null;

export const setSessionCache = (session: Session | null) => {
	cachedSession = session;
};

export const getCachedSession = (): Session | null => cachedSession;
